import * as colors from 'constants/colors';
import styled from "styled-components";

export const Container = styled.header`
  background-color: ${colors.primary01};
  min-height: 60px;
`